import AccordionTab from "components/util/AccordianTab";
import { Autocomplete, Button, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Snackbar, Alert } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { allSelectedData } from "../../../redux/slices/allSelectedDataSlice";
import { clearValidationError } from "../../../redux/slices/formValidationSlice";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { postApiCall } from "../../../services/apiHelper";
import { baseUrl } from "../../../config/config";
import { getAllTenantData } from "../../../redux/slices/allStandardTenantSlice";

const Tenant: React.FC<Record<any, any>> = (props) => {
  const [open, setOpen] = useState(false);
  const [standardTenant, setStandardTenant] = useState('');
  const [naicCode, setNaicCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({ standardTenant: false, naicCode: false });

  const dispatch = useAppDispatch();
  const tenantName = useAppSelector((state) => state.allStandardTenant.data.result);
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const validationErrors = useAppSelector((state) => state.formValidation.errors);
  const {formtype} = useParams();
  
  const handleStandardTenantNameChange = (event: any, newValue: any) => {
    dispatch(allSelectedData({
      ...selectedData,
      standardTenantName: newValue?.standardTenant || '',
      naicS_CodeTenant: newValue?.naiCcode || ''
    }));
    
    if (newValue) {
      dispatch(clearValidationError('standardTenants'));
    }
  }
  
  const handleTenantNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    dispatch(allSelectedData({
      ...selectedData, 
      tenantName: value
    }));
    
    if (value) {
      dispatch(clearValidationError('tenantName'));
    }
  };
  
  const handleUnitNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    dispatch(allSelectedData({
      ...selectedData, 
      unitNumber: value
    }));
    
    if (value) {
      dispatch(clearValidationError('unitNumber'));
    }
  };
  
  const handleUnitSqrFootageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(allSelectedData({
      ...selectedData, 
      unitSquareFootage: event.target.value
    }));  
    
    if (event.target.value) {
      dispatch(clearValidationError('unitSqrFootage'));
    }
  };
  
  return (
    <>
      <AccordionTab
        title={"Tenant"} 
        children={
          <div>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Grid>
                  <label>Tenant Name</label><span className="mandatory"> *</span>
                </Grid>
                <Grid>
                  <TextField 
                    size="small" 
                    fullWidth={true} 
                    inputProps={{
                      min: 0,
                      maxLength: 256,
                      onPaste: (e) => {
                        const pastedText = e.clipboardData.getData('text');
                        if (pastedText.length > 256) {
                          e.preventDefault();
                        }
                      }
                    }}
                    disabled={formtype === "view" || formtype === "approval"}
                    onChange={handleTenantNameChange} 
                    value={selectedData.tenantName}
                    error={!!validationErrors.tenantName}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid>
                  <label>Unit Number</label><span className="mandatory"> *</span>
                </Grid>
                <Grid>
                  <TextField 
                    size="small" 
                    fullWidth={true} 
                    inputProps={{
                      min: 0,
                      maxLength: 256,
                      onPaste: (e) => {
                        const pastedText = e.clipboardData.getData('text');
                        if (pastedText.length > 256) {
                          e.preventDefault();
                        }
                      }
                    }}
                    disabled={formtype === "view" || formtype === "approval"}
                    onChange={handleUnitNumberChange} 
                    value={selectedData.unitNumber}
                    error={!!validationErrors.unitNumber}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid>
                  <label>Unit Square Footage</label><span className="mandatory"> *</span>
                </Grid>
                <Grid>
                  <TextField 
                    size="small" 
                    fullWidth={true} 
                    inputProps={{
                      min: 0,
                      maxLength: 256,
                      onPaste: (e) => {
                        const pastedText = e.clipboardData.getData('text');
                        if (pastedText.length > 256) {
                          e.preventDefault();
                        }
                      }
                    }}
                    disabled={formtype === "view" || formtype === "approval"}
                    onChange={handleUnitSqrFootageChange} 
                    value={selectedData.unitSquareFootage}
                    error={!!validationErrors.unitSqrFootage}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid>
                  <label>Standard Tenant Name</label><span className="mandatory"> *</span>
                </Grid>
                <Grid>
                  <Autocomplete
                    id="StandardTenantName"
                    options={tenantName}
                    getOptionLabel={(option) => option.standardTenant || ''}
                    value={{
                      standardTenant: selectedData.standardTenantName,
                      naiCcode: selectedData.naicS_CodeTenant
                    }}
                    disabled={formtype === "view" || formtype === "approval"}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        placeholder={!selectedData.standardTenantName ? "Select" : ""}
                        error={!!validationErrors.standardTenants}
                      />
                    )}
                    size="small" 
                    fullWidth={true}
                    onChange={handleStandardTenantNameChange}
                    isOptionEqualToValue={(option: any, value: any) => {
                      return option?.standardTenant === value?.standardTenant;
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Grid>
                  <label>NAICS Code</label>
                </Grid>
                <Grid>
                  <TextField 
                    size="small" 
                    fullWidth={true} 
                    inputProps={{
                      min: 0,
                      maxLength: 256,
                    }} 
                    value={selectedData.naicS_CodeTenant ?? ''} 
                    disabled
                  />
                </Grid>
              </Grid>
              <Grid item xs={0} md={1}></Grid>
              {(formtype === 'new' || formtype === 'edit') && (
                <Grid item xs={12} md={3}>
                  <Grid>
                    <br />
                  </Grid>
                  <Grid className="button-container">
                    <Button 
                      variant="contained"
                      color="primary"
                      fullWidth={true}                  
                      className="add-standard-tenant-btn"
                      onClick={() => setOpen(true)}
                    >
                      Add Standard Tenant
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </div>
        } 
      />
      
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Add Standard Tenant
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <label>Standard Tenant <span style={{ color: 'red' }}>*</span></label>
              <TextField
                fullWidth
                size="small"
                value={standardTenant}
                onChange={(e) => {
                  setStandardTenant(e.target.value);
                  if (e.target.value.trim()) {
                    setFieldErrors(prev => ({ ...prev, standardTenant: false }));
                  }
                }}
                error={fieldErrors.standardTenant}
                sx={{ mt: 1 }}
              />
            </Grid>
            <Grid item xs={12}>
              <label>NAIC Code <span style={{ color: 'red' }}>*</span></label>
              <TextField
                fullWidth
                size="small"
                value={naicCode}
                onChange={(e) => {
                  setNaicCode(e.target.value);
                  if (e.target.value.trim()) {
                    setFieldErrors(prev => ({ ...prev, naicCode: false }));
                  }
                }}
                error={fieldErrors.naicCode}
                sx={{ mt: 1 }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            variant="contained" 
            onClick={async () => {
              const hasStandardTenant = standardTenant.trim();
              const hasNaicCode = naicCode.trim();
              
              if (!hasStandardTenant || !hasNaicCode) {
                setFieldErrors({
                  standardTenant: !hasStandardTenant,
                  naicCode: !hasNaicCode
                });
                setValidationError(true);
                return;
              }
              
              setIsSubmitting(true);
              try {
                const url = `${baseUrl}StandardTenant/Add`;
                const payload = {
                  standardTenant: standardTenant.trim(),
                  naiCcode: naicCode.trim()
                };
                await postApiCall(url, payload);
                dispatch(getAllTenantData());
                setStandardTenant('');
                setNaicCode('');
                setFieldErrors({ standardTenant: false, naicCode: false });
                setOpen(false);
                setShowToast(true);
              } catch (error) {
                console.error('Error adding standard tenant:', error);
              } finally {
                setIsSubmitting(false);
              }
            }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => {
              setStandardTenant('');
              setNaicCode('');
              setFieldErrors({ standardTenant: false, naicCode: false });
              setValidationError(false);
              setOpen(false);
            }}
            sx={{ backgroundColor: '#9e9e9e', color: 'white' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      
      <Snackbar
        open={showToast}
        autoHideDuration={4000}
        onClose={() => setShowToast(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setShowToast(false)}
          severity="success"
          sx={{ width: '100%', backgroundColor: '#4caf50', color: 'white' }}
        >
          Standard Tenant added successfully
        </Alert>
      </Snackbar>
      
      <Snackbar
        open={validationError}
        autoHideDuration={4000}
        onClose={() => setValidationError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setValidationError(false)}
          severity="error"
          sx={{ width: '100%', backgroundColor: '#f44336', color: 'white' }}
        >
          Form could not be submitted. Please correct the validation errors
        </Alert>
      </Snackbar>
    </>
  )
}

export default Tenant;